import type { FC } from 'react';
import type { DashboardProfile } from '.';
import { Icon, type IconType } from 'ht-sdk/react';

export const Avatar: FC<{ profile?: DashboardProfile; userIcon: IconType }> = ({ profile, userIcon }) => {
	return (
		<>
			<div className={`flex size-5 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-gray-100`}>
				{profile?.avatarUrl && <img src={profile.avatarUrl} alt={`${profile.name}'s avatar`} className="size-full rounded-full" />}
				{!profile?.avatarUrl && <Icon icon={userIcon} className="size-3 text-gray-400" />}
			</div>
		</>
	);
};
